module.exports = __webpack_public_path__ + "media/images/plans/icon-link-window-e191fc4c3721535bff816ec89473c418.png";